import axiosInstance from "./axiosInstance";

export const fetchExternalConsultant = async (filters: Record<string, string> | null = null) => {
  try {
    const response = await axiosInstance.get("/GetExternalConsultant", {
      params: filters ?? undefined,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching consultants:", error);
    throw error;
  }
};

export const fetchGetMonths = async () => {
  try {
    const response = await axiosInstance.get("/GetMonths");
    return response.data;
  } catch (error) {
    console.error("Error fetching months:", error);
    throw error;
  }
};

export const fetchGetYears = async () => {
  try {
    const response = await axiosInstance.get("/GetYears");
    return response.data;
  } catch (error) {
    console.error("Error fetching years:", error);
    throw error;
  }
};

export const fetchGetProjects = async () => {
  try {
    const response = await axiosInstance.get("/Projects");
    return response.data;
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};

export const updateExternalConsultant = async (data: any) => {
  try {
    const response = await axiosInstance.put("/UpdateExternalConsultant", data);
    return response.data;
  } catch (error) {
    console.error("Error updating consultant:", error);
    throw error;
  }
};

export const createExternalConsultant = async (newConsultant: any) => {
  try {
    const response = await axiosInstance.post("/CreateExternalConsultant", newConsultant);
    return response.data;
  } catch (error) {
    console.error("Error creating consultant:", error);
    throw error;
  }
};

export const deleteExternalConsultant = async (consultantId: number) => {
  try {
    const response = await axiosInstance.delete(`/ExternalConsultant/${consultantId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting consultant:", error);
    throw error;
  }
};
